import { useState, useContext } from "react";

import './styles.css';

import FileInput from "../components/FileInput/FileInput";
import DownloadModel from "../components/DownloadModel/DownloadModel";

import tryExportingElegibles from "../exports/eligibles";
import tryImportingElegibles from "../imports/elegibles";

import useAuthAdmin from "../hooks/useAuthAdmin";
import useSetPageTitle from "../../hooks/useSetPageTitle";

import DefaultLoader from "../../components/Loader/DefaultLoader";
import LinearLoader from "../../components/Loader/LinearLoader";
import AdminContext from "../contexts/AdminContext";

function ElegiblesAdmin() {
    const { currentPromo } = useContext(AdminContext);

    useAuthAdmin();
    useSetPageTitle('Admin');

    const [file, setFile] = useState(null);
    const [loadingImport, setLoadingImport] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [errorImport, setErrorImport] = useState([]);
    const [errorExport, setErrorExport] = useState('');
    const [successImport, setSuccessImport] = useState('');

    const downloadModel = () => {
        const link = document.createElement('a');
        link.href = "/models/modelo-elegiveis.csv";
        link.download = "modelo-elegiveis.csv";
        link.click();
    };
    
    return(
        <>
            <div className="admin-page-container">
                <div className="admin-page-title-container">
                    <p className="admin-page-title">Importar elegíveis</p>
                    {
                        localStorage.getItem('role') !== '1' ?
                        <DownloadModel label="Baixe o modelo de planilha" onClick={downloadModel} />
                        : false
                    }
                </div>
                {
                    localStorage.getItem('role') !== '1' ?
                        <>
                            <FileInput setValue={setFile} />
                            <div className="admin-page-button-container">
                                <button className="admin-page-primary-button" onClick={() => tryImportingElegibles(currentPromo?.id, file, setLoadingImport, setErrorImport, setSuccessImport)}>Enviar</button><br />
                                { loadingImport ? <DefaultLoader /> : false }
                            </div>
                            <p className="admin-page-success-import">{successImport}</p>
                            {errorImport.length > 0 && 
                                <div className="admin-page-error-list">
                                    <h3>Erros:</h3>
                                    {errorImport.map(e => <p key={e.row} className="admin-page-error-import">#{e.row} - {e.message}</p>)}
                                </div>
                            }
                        </>
                        : false
                }
                <div className="admin-page-export-container">
                    <button className="admin-page-secundary-button" onClick={() => tryExportingElegibles(currentPromo?.id, setLoadingExport, setErrorExport)}>Baixar CPFs participantes <span className="button-bold">atuais</span></button>
                    { loadingExport ? <LinearLoader /> : false }
                </div>
                <p className="admin-page-error-import">{errorExport}</p>
            </div>
        </>
    )
}

export default ElegiblesAdmin;